import React, {Component} from 'react';
import ReactDOM from 'react-dom';

// Components
import {Grid} from '@material-ui/core';
import {ExpandLess, ExpandMore} from '@material-ui/icons';
import {T} from 'Actions/translate';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';

class SkuInventoryDetailsDialog extends Component {
    state = {
        skuInventoryExitOpened: false,
        expand: false,
        packageConditionCount: 0,
    };
    componentDidUpdate() {
        const dialogMask = ReactDOM.findDOMNode(
            document.getElementsByClassName('dialog-mask')[0],
        );
        if (dialogMask !== null && this.props.opened) {
            const dialogWrap = dialogMask.children[0];
            const dialogMaskHeight = dialogMask.clientHeight;
            const dialogWrapOffsetHeight = dialogWrap.offsetHeight;
            if (document.getElementById('skuConditionUl') !== null) {
                if (dialogMaskHeight !== 0 && dialogWrapOffsetHeight !== 0) {
                    if (dialogWrapOffsetHeight > dialogMaskHeight) {
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.top = '0%';
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.WebkitTransform = 'translateX(-50%)';
                    } else {
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.top = '50%';
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.WebkitTransform = 'translate(-50%, -50%)';
                    }
                }
            }
        }
    }
    closeDialog = (name) => {
        document.getElementsByClassName('dialog-warp')[0].style.top = '50%';
        document.getElementsByClassName(
            'dialog-warp',
        )[0].style.WebkitTransform = 'translate(-50%, -50%)';
        this.setState({expand: false});
        this.props.closeDialog(name);
    };

    isShowInternalOrderInfor = (skuReplenishmentDetailData) => {
        let isShowFlag = false;
        if (
            typeof skuReplenishmentDetailData.shipDetailMap !== 'undefined' &&
            Object.keys(skuReplenishmentDetailData.shipDetailMap).length > 0 &&
            skuReplenishmentDetailData.shipDetailMap.internalOrderCard.length >
                0
        ) {
            isShowFlag = true;
        }
        return isShowFlag;
    };

    isShowSpShipCardOrderInfor = () => {
        const {skuReplenishmentDetailData} = this.props;
        let isShowFlag = false;
        if (
            typeof skuReplenishmentDetailData !== 'undefined' &&
            typeof skuReplenishmentDetailData.shipDetailMap !== 'undefined' &&
            Object.keys(skuReplenishmentDetailData.shipDetailMap).length > 0 &&
            skuReplenishmentDetailData.shipDetailMap.spShipCard.length > 0
        ) {
            isShowFlag = true;
        }
        return isShowFlag;
    };

    showConditionContent = (skuReplenishmentDetailData) => {
        return (
            <div
                className="package-condition-detail"
                id="packageConditionDetail">
                <div className="sku-condition">
                    <div className="sku-condition-detail">
                        {skuReplenishmentDetailData.physicalInventory !==
                        null ? (
                            <p className="storage-condition-content text-ellipsis">
                                <label>
                                    {T('fone_order_current_inventory')}
                                </label>
                                {skuReplenishmentDetailData.physicalInventory}
                            </p>
                        ) : null}
                        <p className="sku-content text-ellipsis">
                            <label>{T('fone_order_replenishing')}</label>
                            {skuReplenishmentDetailData.replenishingQuantity}
                        </p>
                        <div className="shipping-condition-content text-ellipsis">
                            <label>{T('fone_order_wait_delivery')}</label>
                            {skuReplenishmentDetailData.tobeShippedQuantity}
                        </div>
                    </div>
                </div>

                {typeof skuReplenishmentDetailData.shipDetailMap !==
                    'undefined' &&
                Object.keys(skuReplenishmentDetailData.shipDetailMap).length >
                    0 &&
                skuReplenishmentDetailData.shipDetailMap.etaShipCard.length >
                    0 ? (
                    <div>
                        <div className="inventory-detail-red-notification">
                            {T('提示：您订购的产品可能在下面的补货订单中')}
                        </div>
                        <ul
                            className="f1-order-sku-condition-list"
                            id="skuConditionUl">
                            {Object.keys(
                                skuReplenishmentDetailData.shipDetailMap
                                    .etaShipCard,
                            ).length > 0 ? (
                                <li className="sku-condition-li">
                                    <div className="sku-condition">
                                        {this.renderSkuKit(
                                            skuReplenishmentDetailData
                                                .shipDetailMap.etaShipCard,
                                            false,
                                        )}
                                    </div>
                                </li>
                            ) : null}
                        </ul>
                    </div>
                ) : null}

                {typeof skuReplenishmentDetailData.shipDetailMap !==
                    'undefined' &&
                Object.keys(skuReplenishmentDetailData.shipDetailMap).length >
                    0 &&
                skuReplenishmentDetailData.shipDetailMap.spShipCard.length >
                    0 ? (
                    <div>
                        <div className="inventory-detail-yellow-notification">
                            {T('提示：该SKU的其他补货订单')}
                        </div>
                        <ul
                            className="f1-order-sku-condition-list"
                            id="skuConditionUl">
                            {Object.keys(
                                skuReplenishmentDetailData.shipDetailMap
                                    .spShipCard,
                            ).length > 0 ? (
                                <li className="sku-condition-li">
                                    <div className="sku-condition">
                                        {this.renderSkuKit(
                                            skuReplenishmentDetailData
                                                .shipDetailMap.spShipCard,
                                            true,
                                        )}
                                    </div>
                                </li>
                            ) : null}
                        </ul>
                    </div>
                ) : null}

                {this.isShowInternalOrderInfor(skuReplenishmentDetailData) ? (
                    <div>
                        {!this.isShowSpShipCardOrderInfor() ? (
                            <div className="inventory-detail-yellow-notification">
                                {T('提示：该SKU的其他补货订单')}
                            </div>
                        ) : null}
                        <ul
                            className="f1-order-sku-condition-list"
                            id="skuConditionUl">
                            {Object.keys(
                                skuReplenishmentDetailData.shipDetailMap
                                    .internalOrderCard,
                            ).length > 0 ? (
                                <li className="sku-condition-li">
                                    <div className="sku-condition">
                                        {this.renderInternalOrder(
                                            skuReplenishmentDetailData
                                                .shipDetailMap
                                                .internalOrderCard,
                                            true,
                                        )}
                                    </div>
                                </li>
                            ) : null}
                        </ul>
                    </div>
                ) : null}

                {this.showExpandButton(skuReplenishmentDetailData) ? (
                    <Grid item xs={12} align="center">
                        <BasicButton
                            className="expand-more-btn"
                            type="primary"
                            disabled={false}
                            onClickOfSingleTap={() =>
                                this.expandPackageCondition()
                            }>
                            <span>
                                {this.state.expand ? (
                                    <ExpandLess />
                                ) : (
                                    <ExpandMore />
                                )}
                            </span>
                        </BasicButton>
                    </Grid>
                ) : null}
            </div>
        );
    };

    showExpandButton = (skuReplenishmentDetailData) => {
        let showExpandButtonFlag = false;
        if (Object.keys(skuReplenishmentDetailData).length > 0) {
            let internalOrderCardCount =
                skuReplenishmentDetailData.shipDetailMap.internalOrderCard !==
                    null &&
                skuReplenishmentDetailData.shipDetailMap.internalOrderCard
                    .length;

            let etaShipCardCount =
                skuReplenishmentDetailData.shipDetailMap.etaShipCard !== null &&
                skuReplenishmentDetailData.shipDetailMap.etaShipCard.length;

            if (etaShipCardCount > 2 || internalOrderCardCount > 2) {
                showExpandButtonFlag = true;
            }
        }

        console.log(
            'showExpandButtonFlag===================================',
            showExpandButtonFlag,
        );
        return showExpandButtonFlag;
    };

    renderSkuKit = (skuKitComponents, isYellowFlag) => {
        return (
            <div className="sku-kit-detail">
                <ul
                    className="sku-kit-list"
                    id={isYellowFlag ? 'yellowSkuKitUl' : 'skuKitUl'}>
                    {skuKitComponents.map((skuKitCondition, index) => (
                        <li
                            key={index}
                            className={
                                index > 1
                                    ? 'sku-kit-li hidden-sku-kit-li'
                                    : 'sku-kit-li'
                            }>
                            <div className="sku-kit">
                                <div className="sku-title-area">
                                    <div className="show-sku">
                                        {skuKitCondition.sku}
                                    </div>
                                    <div className="show-deliver-quantity">
                                        <label className="shippment_quantity-label">
                                            {T(
                                                'shippment_details_shippment_quantity',
                                            )}
                                        </label>
                                        <label className="shippment_quantity-value">
                                            {skuKitCondition.shippedQuantity}
                                        </label>
                                    </div>
                                </div>
                                {/* {skuKitCondition.actualShipDate !== '' && skuKitCondition.actualShipDate !== '0' ? null : (
                                    <div className="pre-delivery-time">
                                        <label className="pre-delivery-time-label">
                                            {T('fone_order_pre_deliver_time')}
                                        </label>
                                        {skuKitCondition.etaDate ? (
                                            <label className="pre-delivery-time-value">
                                                {skuKitCondition.etaDate}
                                            </label>
                                        ) : (
                                            <label className="cs_email_value">
                                                {T(
                                                    'fone_order_inventory_detail_cs_email',
                                                )}
                                            </label>
                                        )}
                                    </div>
								)} */}

                                {!isYellowFlag ? (
                                    skuKitCondition.actualShipDate === '' ||
                                    skuKitCondition.actualShipDate === '0' ? (
                                        <div className="pre-delivery-time">
                                            <label className="pre-delivery-time-label">
                                                {T(
                                                    'fone_order_pre_deliver_time',
                                                )}
                                            </label>
                                            {skuKitCondition.etaDate ? (
                                                <label className="pre-delivery-time-value">
                                                    {skuKitCondition.etaDate}
                                                </label>
                                            ) : (
                                                <label className="cs_email_value">
                                                    {T(
                                                        'fone_order_inventory_detail_cs_email',
                                                    )}
                                                </label>
                                            )}
                                        </div>
                                    ) : null
                                ) : null}
                                <div className="kit-storage-condition-detail eone-data">
                                    <p className="kit-storage-condition-content text-ellipsis">
                                        <label>{T('order_eone_number')}</label>
                                        {skuKitCondition.orderNumber}
                                    </p>
                                    <p className="kit-shipping-state text-ellipsis">
                                        <label>{T('order_eone_status')}</label>
                                        {skuKitCondition.statusDesc}
                                    </p>
                                </div>
                                <div className="kit-storage-condition-detail eone-data">
                                    <p className="kit-shipping-state text-ellipsis">
                                        <label>{T('order_wharehouse')}</label>
                                        {skuKitCondition.branchDesc}
                                    </p>
                                </div>
                                {(skuKitCondition.shipmentNumber !== '' &&
                                    skuKitCondition.shipmentNumber !== '0') ||
                                (skuKitCondition.actualShipDate !== '' &&
                                    skuKitCondition.actualShipDate !== '0') ? (
                                    <div className="kit-storage-condition-detail eone-data">
                                        {skuKitCondition.shipmentNumber !==
                                            '' &&
                                        skuKitCondition.shipmentNumber !==
                                            '0' ? (
                                            <p className="kit-storage-condition-content text-ellipsis">
                                                <label>
                                                    {T(
                                                        'shippment_details_shipment_number',
                                                    )}
                                                </label>
                                                {skuKitCondition.shipmentNumber}
                                            </p>
                                        ) : null}

                                        {skuKitCondition.actualShipDate !==
                                            '' &&
                                        skuKitCondition.actualShipDate !==
                                            '0' ? (
                                            <p className="kit-shipping-condition-content text-ellipsis">
                                                <label>
                                                    {T(
                                                        'shippment_details_actual_ship_date',
                                                    )}
                                                </label>
                                                {skuKitCondition.actualShipDate}
                                            </p>
                                        ) : null}
                                    </div>
                                ) : null}
                                {isYellowFlag &&
                                (skuKitCondition.actualShipDate === '0' ||
                                    skuKitCondition.actualShipDate === '') &&
                                !skuKitCondition.etaDate &&
                                skuKitCondition.availabilityDate !== '' &&
                                skuKitCondition.availabilityDate !== '0' &&
                                (skuKitCondition.lastStatus === '900' ||
                                    skuKitCondition.lastStatus === '902' ||
                                    skuKitCondition.lastStatus === '904' ||
                                    skuKitCondition.lastStatus === '912') ? (
                                    <div className="kit-shipping-condition-detail">
                                        <p className="kit-shipping-condition-content text-ellipsis">
                                            <label>
                                                {T(
                                                    'fone_order_pre_deliver_time',
                                                )}
                                                :
                                            </label>
                                            {skuKitCondition.availabilityDate}
                                        </p>
                                    </div>
                                ) : null}
                                {/* {skuKitCondition.shipmentNumber !== '' && skuKitCondition.shipmentNumber !== '0'  ? <div className='kit-shipping-condition-detail'>
										<p className='kit-storage-condition-content text-ellipsis'><label>{T('shippment_details_shipment_number')}:</label>{ skuKitCondition.shipmentNumber }</p>
									</div> : null}

									{skuKitCondition.actualShipDate !== '' && skuKitCondition.actualShipDate !== '0' ? <div className='kit-shipping-condition-detail'>
										<p className='kit-shipping-condition-content text-ellipsis'><label>{T('shippment_details_actual_ship_date')}:</label>{skuKitCondition.actualShipDate}</p>
									</div> : null} */}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    isShowCurrentInteralInfor = (internalOrderIndex) => {
        const {skuReplenishmentDetailData} = this.props;
        let isShowFlag = false;
        if (
            typeof skuReplenishmentDetailData !== 'undefined' &&
            typeof skuReplenishmentDetailData.shipDetailMap !== 'undefined' &&
            Object.keys(skuReplenishmentDetailData.shipDetailMap).length > 0 &&
            skuReplenishmentDetailData.shipDetailMap.spShipCard.length > 0
        ) {
            let spShipCardCount =
                skuReplenishmentDetailData.shipDetailMap.spShipCard.length;
            if (spShipCardCount < 2) {
                if (spShipCardCount === 1 && internalOrderIndex > 0) {
                    isShowFlag = true;
                } else if (spShipCardCount === 0 && internalOrderIndex > 1) {
                    isShowFlag = true;
                }
            } else if (spShipCardCount >= 2) {
                isShowFlag = true;
            }
        } else {
            if (internalOrderIndex > 1) {
                isShowFlag = true;
            }
        }
        return isShowFlag;
    };

    renderInternalOrder = (skuKitComponents, isYellowFlag) => {
        return (
            <div className="sku-kit-detail">
                <ul className="sku-kit-list" id="internalOrderSkuKitUl">
                    {skuKitComponents.map((skuKitCondition, index) => (
                        <li
                            key={index}
                            className={
                                this.isShowCurrentInteralInfor(index)
                                    ? 'sku-kit-li hidden-sku-kit-li'
                                    : 'sku-kit-li'
                            }>
                            <div className="sku-kit">
                                <div className="sku-title-area">
                                    <div className="show-sku">
                                        {skuKitCondition.sku}
                                    </div>
                                    <div className="show-deliver-quantity">
                                        <label className="shippment_quantity-label">
                                            {T(
                                                'shippment_details_shippment_quantity',
                                            )}
                                        </label>
                                        <label className="shippment_quantity-value">
                                            {skuKitCondition.shippedQuantity}
                                        </label>
                                    </div>
                                </div>

                                <div className="kit-storage-condition-detail eone-data">
                                    <p className="internal-order-number text-ellipsis">
                                        <label>
                                            {T(
                                                'fone_order_internal_order_number',
                                            )}
                                        </label>
                                        {skuKitCondition.orderNumber}
                                    </p>
                                </div>
                                <div className="kit-storage-condition-detail eone-data">
                                    <p className="kit-shipping-state text-ellipsis">
                                        <label>{T('order_wharehouse')}</label>
                                        {skuKitCondition.branchDesc}
                                    </p>
                                    <p className="kit-shipping-state text-ellipsis">
                                        <label>
                                            {T(
                                                'fone_order_internal_order_status',
                                            )}
                                        </label>
                                        {skuKitCondition.statusDesc}
                                    </p>
                                </div>
                                {skuKitCondition.actualShipDate ? (
                                    <div className="kit-storage-condition-detail eone-data">
                                        <p className="delivery-time text-ellipsis">
                                            <label>
                                                {T('fone_order_delivery_time')}
                                            </label>
                                            {skuKitCondition.actualShipDate}
                                        </p>
                                    </div>
                                ) : null}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    expandPackageCondition = () => {
        const expand = this.state.expand;

        let spShipCardSkuKitUlCount = 0;
        let internalOrderSkuKitUlCount = 0;
        if (document.getElementById('yellowSkuKitUl') !== null) {
            spShipCardSkuKitUlCount = document
                .getElementById('yellowSkuKitUl')
                .getElementsByTagName('li').length;
        }
        if (document.getElementById('internalOrderSkuKitU') !== null) {
            internalOrderSkuKitUlCount = document
                .getElementById('internalOrderSkuKitU')
                .getElementsByTagName('li').length;
        }
        if (document.getElementById('skuKitUl') !== null) {
            if (expand) {
                for (
                    var i = 0;
                    i <
                    document
                        .getElementById('skuKitUl')
                        .getElementsByTagName('li').length;
                    i++
                ) {
                    if (i > 1) {
                        document
                            .getElementById('skuKitUl')
                            .getElementsByTagName('li')
                            [i].setAttribute(
                                'style',
                                'display: none !important',
                            );
                    }
                }
                this.setState({
                    expand: false,
                });
            } else {
                for (
                    var j = 0;
                    j <
                    document
                        .getElementById('skuKitUl')
                        .getElementsByTagName('li').length;
                    j++
                ) {
                    if (j > 1) {
                        document
                            .getElementById('skuKitUl')
                            .getElementsByTagName('li')
                            [j].setAttribute(
                                'style',
                                'display: block !important',
                            );
                    }
                }
                this.setState({
                    expand: true,
                });
            }
        }
        if (document.getElementById('yellowSkuKitUl') !== null) {
            if (expand) {
                for (
                    var i = 0;
                    i <
                    document
                        .getElementById('yellowSkuKitUl')
                        .getElementsByTagName('li').length;
                    i++
                ) {
                    if (i > 1) {
                        document
                            .getElementById('yellowSkuKitUl')
                            .getElementsByTagName('li')
                            [i].setAttribute(
                                'style',
                                'display: none !important',
                            );
                    }
                }
                this.setState({
                    expand: false,
                });
            } else {
                for (
                    var j = 0;
                    j <
                    document
                        .getElementById('yellowSkuKitUl')
                        .getElementsByTagName('li').length;
                    j++
                ) {
                    if (j > 1) {
                        document
                            .getElementById('yellowSkuKitUl')
                            .getElementsByTagName('li')
                            [j].setAttribute(
                                'style',
                                'display: block !important',
                            );
                    }
                }
                this.setState({
                    expand: true,
                });
            }
        }
        if (document.getElementById('internalOrderSkuKitUl') !== null) {
            if (expand) {
                for (
                    var i = 0;
                    i <
                    document
                        .getElementById('internalOrderSkuKitUl')
                        .getElementsByTagName('li').length;
                    i++
                ) {
                    if (this.isShowSpShipCardOrderInfor()) {
                        if (spShipCardSkuKitUlCount === 0) {
                            if (i > 1) {
                                document
                                    .getElementById('internalOrderSkuKitUl')
                                    .getElementsByTagName('li')
                                    [i].setAttribute(
                                        'style',
                                        'display: none !important',
                                    );
                            }
                        } else if (spShipCardSkuKitUlCount === 1) {
                            if (i > 0) {
                                document
                                    .getElementById('internalOrderSkuKitUl')
                                    .getElementsByTagName('li')
                                    [i].setAttribute(
                                        'style',
                                        'display: none !important',
                                    );
                            }
                        } else if (spShipCardSkuKitUlCount >= 2) {
                            document
                                .getElementById('internalOrderSkuKitUl')
                                .getElementsByTagName('li')
                                [i].setAttribute(
                                    'style',
                                    'display: none !important',
                                );
                        }
                    } else {
                        if (i > 1) {
                            document
                                .getElementById('internalOrderSkuKitUl')
                                .getElementsByTagName('li')
                                [i].setAttribute(
                                    'style',
                                    'display: none !important',
                                );
                        }
                    }
                }
                this.setState({
                    expand: false,
                });
            } else {
                for (
                    var j = 0;
                    j <
                    document
                        .getElementById('internalOrderSkuKitUl')
                        .getElementsByTagName('li').length;
                    j++
                ) {
                    if (this.isShowSpShipCardOrderInfor()) {
                        if (j >= 0) {
                            document
                                .getElementById('internalOrderSkuKitUl')
                                .getElementsByTagName('li')
                                [j].setAttribute(
                                    'style',
                                    'display: block !important',
                                );
                        }
                    } else {
                        if (j > 1) {
                            document
                                .getElementById('internalOrderSkuKitUl')
                                .getElementsByTagName('li')
                                [j].setAttribute(
                                    'style',
                                    'display: block !important',
                                );
                        }
                    }
                }
                this.setState({
                    expand: true,
                });
            }
        }
    };

    render() {
        const {opened, skuReplenishmentDetailData} = this.props;
        return (
            <Dialog
                dialogDidClose={() =>
                    this.closeDialog('skuInventoryExitOpened')
                }
                opened={opened}
                options={{bgClickClose: true}}>
                <div className="logout-dialog">
                    <Grid className="dialog-title" container spacing={0}>
                        <Grid item xs={12}>
                            <span>
                                {T('shippment_inventory_logistics_information')}
                            </span>
                        </Grid>
                    </Grid>

                    <Grid
                        className="dialog-content shipping-details-dialog-content"
                        container
                        spacing={0}
                        justify={'center'}>
                        <Grid item xs={12} className="simple-table-setting">
                            {this.showConditionContent(
                                skuReplenishmentDetailData,
                            )}
                        </Grid>
                    </Grid>

                    <Grid container spacing={0}>
                        <Grid item xs={12} align="center">
                            <BasicButton
                                className="close-confirm-btn"
                                type="primary"
                                disabled={false}
                                onClickOfSingleTap={() =>
                                    this.closeDialog('skuInventoryExitOpened')
                                }>
                                <span>{T('shopping_cart_close')}</span>
                            </BasicButton>
                        </Grid>
                    </Grid>
                </div>
            </Dialog>
        );
    }
}

export default SkuInventoryDetailsDialog;
